import { Injectable } from '@angular/core';
import { Globals } from './globals';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Report } from 'app/models/report';
import { ScopeService } from './scope.service';
import { ReportAutoUpload } from 'app/models/report-auto-upload';
import { getDefaultTimezone } from 'app/helpers/utils';

@Injectable({ providedIn: 'root' })
export class ReportService {

    constructor(private http: HttpClient, private globals: Globals, 
                private formBuilder: FormBuilder, private scopeService: ScopeService) {
    }

    formGroup(report: Report = null) {

        let autoUploads = this.formBuilder.array([])
        if(report && report.auto_uploads) {
            report.auto_uploads.forEach( a => {
                autoUploads.push(this.getReportAutoUploadFormGroup(a));
            });
        }

        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(report)? report.id: null],
            name: [(report)? report.name: '', [Validators.required, Validators.maxLength(255)]],
            url: [(report)? report.url: '', [Validators.required]],
            expression: [(report)? report.expression: '* * * * *', [Validators.required, Validators.maxLength(255)]],
            timezone: [(report)? report.timezone: getDefaultTimezone(), [Validators.required, Validators.maxLength(255)]],
            to_scope: this.scopeService.getScopeFormGroup(report? report.to_scope: null),
            auto_uploads: autoUploads
        });

        frmGrp.get('url').valueChanges.subscribe((newValue) => {
            const regexRes: RegExpExecArray = /^.*\"(http[^\"]*)\".*$/.exec(newValue);

            if (regexRes && regexRes[1] != newValue) {
                frmGrp.get('url').setValue(regexRes[1]);
            }
        });

        return frmGrp;
    }

    getReportAutoUploadFormGroup(reportAutoUpload: ReportAutoUpload) {
        let formControls: any = {
            id: [undefined],
            path: [reportAutoUpload.path, Validators.required],
            should_overwrite: [reportAutoUpload.should_overwrite? 1: 0],
            file_name_prefix: [reportAutoUpload.file_name_prefix],
            file_name_suffix: [reportAutoUpload.file_name_suffix],
            storage_id: [reportAutoUpload.storage_id]
          };
          
          return this.formBuilder.group(formControls, { });
    }

    public getAll() {
        return this.http.get<Report[]>(`${this.globals.api_base_url}/reports`, {});
    }

    public getById(reportId: number) {
        return this.http.get<Report>(`${this.globals.api_base_url}/report/${reportId}`, {});
    }

    public delete(reportId: number) {
        return this.http.delete(`${this.globals.api_base_url}/report/${reportId}`, {});
    }

    public put(report: Report) {
        return this.http.put(`${this.globals.api_base_url}/report`, report);
    }
}